import { useEffect } from 'react'
import PATHS from '@/routes/paths'

/** @param {object} m */
export function useValidateUrlThread(m) {
  const { activePrimaryKey, urlThreadId, navThreads, navigate } = m
  useEffect(() => {
    if (activePrimaryKey !== 'home') return
    if (!urlThreadId) return
    if (!navThreads.some((t) => t.id === urlThreadId)) {
      navigate(PATHS.HOME, { replace: true })
    }
  }, [activePrimaryKey, urlThreadId, navThreads, navigate])
}
